import React from 'react';

export interface InfoRowProps {
  /** Left-hand field label */
  label: string;
  /** Field value / editor rendered on the right */
  children: React.ReactNode;
}

/**
 * InfoRow — label + value row used by the Project detail sidebar panels.
 *
 * Extracted from `pages/Projects/ProjectDetail.tsx` so sidebar panels split out
 * into their own components (e.g. `Projects/AtsPanel`) render identical rows.
 */
export function InfoRow({ label, children }: InfoRowProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 py-1.5">
      <span className="text-xs font-medium text-slate-500 sm:w-28 flex-shrink-0">{label}</span>
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
}

export default InfoRow;
